import Vue from 'vue'
import Router from 'vue-router'
import {
    postRequest,
    postJsonRequest,
    uploadFileRequest,
    uploadFilePutRequest,
    getRequest,
    deleteRequest,
    putRequest,
    putJsonRequest
} from '../axios/api'
import home from '@/components/homepage/home';
import adminHome from '@/components/admin/adminHome'
import flight from "@/components/home/flightDetail/flightDetailMain"
import register from '@/components/register'
import index from '@/components/dashboard/index'
import inspectionPlan from '@/components/home/inspectionPlan'
import inspection from '@/components/dashboard/inspection'
import logistics from '@/components/dashboard/logistics'
import anchorPads from '@/components/dashboard/anchorPads'
import flightDetailMain from '@/components/home/flightDetail/flightDetailMain'
import secondDTaskControl from '@/components/home/TaskControl'
import threeDSpaceControl from '@/components/home/ThreedSpaceControll'
import secondDCityControl from '@/components/home/MunicipalLevelData'

Vue.prototype.postRequest = postRequest;
Vue.prototype.postJsonRequest = postJsonRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.uploadFilePutRequest = uploadFilePutRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.putJsonRequest = putJsonRequest;
Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                isLogin: false
            }, // 添加该字段，表示进入这个路由是不需要登录的
            component: (resolve) => require(['@/components/Login.vue'], resolve)
        },
      {
        path: '/flightDetailMain',
        name: 'flightDetailMain',
        component: flightDetailMain,
      },
      {
        path: '/index',
        name: 'index',
        component: index,
      },
      {
        path: '/inspection',
        name: 'inspection',
        component: inspection,
      },
      {
        path: '/logistics',
        name: 'logistics',
        component: logistics,
      },

      {
        path: '/anchorPads',
        name: 'anchorPads',
        component: anchorPads,
      },
      {
        path: '/inspectionPlan',
        name: 'inspectionPlan',
        component: inspectionPlan,
      },

        {
            path: '/home',
            name: 'home',
            component: home,
        },
        {
            path:'/adminHome',
            name: 'adminHome',
            component: adminHome
        },
        {
            path:'/flight',
            name: 'flight',
            component: flight
        },
        {
            path:'/register',
            name: 'register',
            meta: {
                isLogin: false
            }, // 添加该字段，表示进入这个路由是不需要登录的
            component: register,
        },
    ]
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登录
router.beforeEach((to, from, next) => {
    if (to.path === '/login' || to.path === '/register') {
        next();
    } else {
        let userData = localStorage.getItem('tokenId');
        if (!userData) {
            userData = localStorage.getItem("tokenId");
            if (!userData) {
                userData = sessionStorage.getItem("tokenId");
            }
        }
        if (userData) {
            next();
        } else {
            next('/login');
        }
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js